import { render, staticRenderFns } from "./activityGoodsList.vue?vue&type=template&id=78c8ec69&scoped=true"
import script from "./activityGoodsList.vue?vue&type=script&lang=js"
export * from "./activityGoodsList.vue?vue&type=script&lang=js"
import style0 from "./activityGoodsList.vue?vue&type=style&index=0&id=78c8ec69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c8ec69",
  null
  
)

export default component.exports